import React from 'react';


const Gallery = () => {
  return (
	<>
	        <div id="rec726811074" class="r t-rec t-rec_pt_30 t-rec_pt-res-480_15 t-rec_pb_30 t-rec_pb-res-480_15"
            style={{ paddingTop: '30px', paddingBottom: '30px', backgroundColor: '#1d1c21' }} data-animationappear="off"
            data-record-type="979" data-bg-color="#1d1c21">
            <div class="t979">
                <div class="t979__container t-container_100">
                    <div class="t979__grid ">
                        <div class="t979__grid-item t-img-1"  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                                
                            <img class="t979__image t-slds__img" src="https://static.tildacdn.com/tild3466-3763-4762-b765-313861343932/0001.JPG"
                                data-original="https://static.tildacdn.com/tild3466-3763-4762-b765-313861343932/0001.JPG"
                                data-zoomable="yes" data-zoom-target="0"
                                data-img-zoom-url="https://static.tildacdn.com/tild3466-3763-4762-b765-313861343932/0001.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild6662-3234-4562-a563-646639666632/-/format/webp/0010.JPG"
                                data-original="https://static.tildacdn.com/tild6662-3234-4562-a563-646639666632/0010.JPG"
                                data-zoomable="yes" data-zoom-target="2"
                                data-img-zoom-url="https://static.tildacdn.com/tild6662-3234-4562-a563-646639666632/0010.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://static.tildacdn.com/tild3961-3039-4333-a335-613032306632/0007.JPG"
                                data-original="https://static.tildacdn.com/tild3961-3039-4333-a335-613032306632/0007.JPG"
                                data-zoomable="yes" data-zoom-target="3"
                                data-img-zoom-url="https://static.tildacdn.com/tild3961-3039-4333-a335-613032306632/0007.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3939-6366-4766-b131-373936383735/-/resize/946x/-/format/webp/0126.JPG"
                                data-original="https://static.tildacdn.com/tild3939-6366-4766-b131-373936383735/0126.JPG"
                                data-zoomable="yes" data-zoom-target="4"
                                data-img-zoom-url="https://static.tildacdn.com/tild3939-6366-4766-b131-373936383735/0126.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild6136-3030-4330-b835-356364626534/-/resize/946x/-/format/webp/0336.JPG"
                                data-original="https://static.tildacdn.com/tild6136-3030-4330-b835-356364626534/0336.JPG"
                                data-zoomable="yes" data-zoom-target="5"
                                data-img-zoom-url="https://static.tildacdn.com/tild6136-3030-4330-b835-356364626534/0336.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild6264-6435-4362-b136-306435623531/-/format/webp/0002.JPG"
                                data-original="https://static.tildacdn.com/tild6264-6435-4362-b136-306435623531/0002.JPG"
                                data-zoomable="yes" data-zoom-target="7"
                                data-img-zoom-url="https://static.tildacdn.com/tild6264-6435-4362-b136-306435623531/0002.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3466-3463-4963-a436-383734373662/-/format/webp/0042.JPG"
                                data-original="https://static.tildacdn.com/tild3466-3463-4963-a436-383734373662/0042.JPG"
                                data-zoomable="yes" data-zoom-target="8"
                                data-img-zoom-url="https://static.tildacdn.com/tild3466-3463-4963-a436-383734373662/0042.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild6537-3739-4765-a432-346439303831/-/resize/946x/-/format/webp/0008.JPG"
                                data-original="https://static.tildacdn.com/tild6537-3739-4765-a432-346439303831/0008.JPG"
                                data-zoomable="yes" data-zoom-target="9"
                                data-img-zoom-url="https://static.tildacdn.com/tild6537-3739-4765-a432-346439303831/0008.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            

                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3265-6533-4136-b438-646163633163/-/resize/946x/-/format/webp/0315.JPG"
                                data-original="https://static.tildacdn.com/tild3265-6533-4136-b438-646163633163/0315.JPG"
                                data-zoomable="yes" data-zoom-target="10"
                                data-img-zoom-url="https://static.tildacdn.com/tild3265-6533-4136-b438-646163633163/0315.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            

                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3562-3962-4061-b433-363737363331/-/resize/946x/-/format/webp/0112.JPG"
                                data-original="https://static.tildacdn.com/tild3562-3962-4061-b433-363737363331/0112.JPG"
                                data-zoomable="yes" data-zoom-target="11"
                                data-img-zoom-url="https://static.tildacdn.com/tild3562-3962-4061-b433-363737363331/0112.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            

                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3530-3333-4362-a235-663766653661/-/resize/976x/-/format/webp/0013.JPG"
                                data-original="https://static.tildacdn.com/tild3530-3333-4362-a235-663766653661/0013.JPG"
                                data-zoomable="yes" data-zoom-target="13"
                                data-img-zoom-url="https://static.tildacdn.com/tild3530-3333-4362-a235-663766653661/0013.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            

                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3536-3434-4234-a437-323931633539/-/resize/976x/-/format/webp/0016.JPG"
                                data-original="https://static.tildacdn.com/tild3536-3434-4234-a437-323931633539/0016.JPG"
                                data-zoomable="yes" data-zoom-target="15"
                                data-img-zoom-url="https://static.tildacdn.com/tild3536-3434-4234-a437-323931633539/0016.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3030-6431-4233-b864-323263633634/-/resize/946x/-/format/webp/0019.JPG"
                                data-original="https://static.tildacdn.com/tild3030-6431-4233-b864-323263633634/0019.JPG"
                                data-zoomable="yes" data-zoom-target="16"
                                data-img-zoom-url="https://static.tildacdn.com/tild3030-6431-4233-b864-323263633634/0019.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3266-3039-4430-b832-316461343737/-/resize/946x/-/format/webp/0021.JPG"
                                data-original="https://static.tildacdn.com/tild3266-3039-4430-b832-316461343737/0021.JPG"
                                data-zoomable="yes" data-zoom-target="17"
                                data-img-zoom-url="https://static.tildacdn.com/tild3266-3039-4430-b832-316461343737/0021.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3133-6362-4161-b462-366561363138/-/resize/946x/-/format/webp/0026.JPG"
                                data-original="https://static.tildacdn.com/tild3133-6362-4161-b462-366561363138/0026.JPG"
                                data-zoomable="yes" data-zoom-target="18"
                                data-img-zoom-url="https://static.tildacdn.com/tild3133-6362-4161-b462-366561363138/0026.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3136-3336-4835-a563-316439663261/-/resize/946x/-/format/webp/0027.JPG"
                                data-original="https://static.tildacdn.com/tild3136-3336-4835-a563-316439663261/0027.JPG"
                                data-zoomable="yes" data-zoom-target="19"
                                data-img-zoom-url="https://static.tildacdn.com/tild3136-3336-4835-a563-316439663261/0027.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild6362-3435-4430-a464-373865343632/-/resize/946x/-/format/webp/0101.JPG"
                                data-original="https://static.tildacdn.com/tild6362-3435-4430-a464-373865343632/0101.JPG"
                                data-zoomable="yes" data-zoom-target="20"
                                data-img-zoom-url="https://static.tildacdn.com/tild6362-3435-4430-a464-373865343632/0101.JPG"
                                />
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3037-3336-4632-b337-366163336662/-/resize/946x/-/format/webp/0022.JPG"
                                data-original="https://static.tildacdn.com/tild3037-3336-4632-b337-366163336662/0022.JPG"
                                data-zoomable="yes" data-zoom-target="21"
                                data-img-zoom-url="https://static.tildacdn.com/tild3037-3336-4632-b337-366163336662/0022.JPG"
                                />
                        </div>


                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild6537-3464-4662-b330-383733396235/-/resize/946x/-/format/webp/0041.JPG"
                                data-original="https://static.tildacdn.com/tild6537-3464-4662-b330-383733396235/0041.JPG"
                                data-zoomable="yes" data-zoom-target="26"
                                data-img-zoom-url="https://static.tildacdn.com/tild6537-3464-4662-b330-383733396235/0041.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild6265-6134-4530-a135-656663656237/-/resize/946x/-/format/webp/0042.JPG"
                                data-original="https://static.tildacdn.com/tild6265-6134-4530-a135-656663656237/0042.JPG"
                                data-zoomable="yes" data-zoom-target="27"
                                data-img-zoom-url="https://static.tildacdn.com/tild6265-6134-4530-a135-656663656237/0042.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3365-6331-4261-b762-653030396264/-/resize/946x/-/format/webp/0045.JPG"
                                data-original="https://static.tildacdn.com/tild3365-6331-4261-b762-653030396264/0045.JPG"
                                data-zoomable="yes" data-zoom-target="28"
                                data-img-zoom-url="https://static.tildacdn.com/tild3365-6331-4261-b762-653030396264/0045.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3332-6262-4332-b635-323066356431/-/format/webp/0236.JPG"
                                data-original="https://static.tildacdn.com/tild3332-6262-4332-b635-323066356431/0236.JPG"
                                data-zoomable="yes" data-zoom-target="29"
                                data-img-zoom-url="https://static.tildacdn.com/tild3332-6262-4332-b635-323066356431/0236.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild6230-6439-4138-a235-613330653934/-/format/webp/0047.JPG"
                                data-original="https://static.tildacdn.com/tild6230-6439-4138-a235-613330653934/0047.JPG"
                                data-zoomable="yes" data-zoom-target="31"
                                data-img-zoom-url="https://static.tildacdn.com/tild6230-6439-4138-a235-613330653934/0047.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild6533-6437-4231-b735-623663303966/-/resize/946x/-/format/webp/0190.JPG"
                                data-original="https://static.tildacdn.com/tild6533-6437-4231-b735-623663303966/0190.JPG"
                                data-zoomable="yes" data-zoom-target="32"
                                data-img-zoom-url="https://static.tildacdn.com/tild6533-6437-4231-b735-623663303966/0190.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3730-3736-4639-b036-653739353064/-/resize/946x/-/format/webp/0049.JPG"
                                data-original="https://static.tildacdn.com/tild3730-3736-4639-b036-653739353064/0049.JPG"
                                data-zoomable="yes" data-zoom-target="33"
                                data-img-zoom-url="https://static.tildacdn.com/tild3730-3736-4639-b036-653739353064/0049.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild6662-3235-4331-b236-653434353134/-/resize/946x/-/format/webp/0044.JPG"
                                data-original="https://static.tildacdn.com/tild6662-3235-4331-b236-653434353134/0044.JPG"
                                data-zoomable="yes" data-zoom-target="34"
                                data-img-zoom-url="https://static.tildacdn.com/tild6662-3235-4331-b236-653434353134/0044.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3638-3764-4331-b531-356339663437/-/resize/946x/-/format/webp/0050.JPG"
                                data-original="https://static.tildacdn.com/tild3638-3764-4331-b531-356339663437/0050.JPG"
                                data-zoomable="yes" data-zoom-target="35"
                                data-img-zoom-url="https://static.tildacdn.com/tild3638-3764-4331-b531-356339663437/0050.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3665-6163-4634-b739-633732636631/-/resize/946x/-/format/webp/0003.JPG"
                                data-original="https://static.tildacdn.com/tild3665-6163-4634-b739-633732636631/0003.JPG"
                                data-zoomable="yes" data-zoom-target="36"
                                data-img-zoom-url="https://static.tildacdn.com/tild3665-6163-4634-b739-633732636631/0003.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild6533-6434-4266-b439-613334356537/-/resize/946x/-/format/webp/0180.JPG"
                                data-original="https://static.tildacdn.com/tild6533-6434-4266-b439-613334356537/0180.JPG"
                                data-zoomable="yes" data-zoom-target="37"
                                data-img-zoom-url="https://static.tildacdn.com/tild6533-6434-4266-b439-613334356537/0180.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3166-6534-4538-b433-633335366235/-/format/webp/0051.JPG"
                                data-original="https://static.tildacdn.com/tild3166-6534-4538-b433-633335366235/0051.JPG"
                                data-zoomable="yes" data-zoom-target="38"
                                data-img-zoom-url="https://static.tildacdn.com/tild3166-6534-4538-b433-633335366235/0051.JPG"
                                alt=""/>
                        </div>


                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3730-3363-4238-b466-353361613131/-/format/webp/0054.JPG"
                                data-original="https://static.tildacdn.com/tild3730-3363-4238-b466-353361613131/0054.JPG"
                                data-zoomable="yes" data-zoom-target="41"
                                data-img-zoom-url="https://static.tildacdn.com/tild3730-3363-4238-b466-353361613131/0054.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3530-3632-4535-b139-366332613136/-/format/webp/0055.JPG"
                                data-original="https://static.tildacdn.com/tild3530-3632-4535-b139-366332613136/0055.JPG"
                                data-zoomable="yes" data-zoom-target="43"
                                data-img-zoom-url="https://static.tildacdn.com/tild3530-3632-4535-b139-366332613136/0055.JPG"
                                alt=""/>
                        </div>



                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3863-3032-4563-a365-323962333761/-/resize/976x/-/format/webp/0073.JPG"
                                data-original="https://static.tildacdn.com/tild3863-3032-4563-a365-323962333761/0073.JPG"
                                data-zoomable="yes" data-zoom-target="47"
                                data-img-zoom-url="https://static.tildacdn.com/tild3863-3032-4563-a365-323962333761/0073.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3865-3336-4130-a266-396132303037/-/resize/946x/-/format/webp/0075.JPG"
                                data-original="https://static.tildacdn.com/tild3865-3336-4130-a266-396132303037/0075.JPG"
                                data-zoomable="yes" data-zoom-target="48"
                                data-img-zoom-url="https://static.tildacdn.com/tild3865-3336-4130-a266-396132303037/0075.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild6263-3333-4563-b036-333538383335/-/resize/946x/-/format/webp/0026.JPG"
                                data-original="https://static.tildacdn.com/tild6263-3333-4563-b036-333538383335/0026.JPG"
                                data-zoomable="yes" data-zoom-target="49"
                                data-img-zoom-url="https://static.tildacdn.com/tild6263-3333-4563-b036-333538383335/0026.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3033-3638-4162-b937-383831346566/-/resize/946x/-/format/webp/0081.JPG"
                                data-original="https://static.tildacdn.com/tild3033-3638-4162-b937-383831346566/0081.JPG"
                                data-zoomable="yes" data-zoom-target="50"
                                data-img-zoom-url="https://static.tildacdn.com/tild3033-3638-4162-b937-383831346566/0081.JPG"
                                alt=""/>
                        </div>

                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3565-3066-4830-b661-366433323564/-/format/webp/0084.JPG"
                                data-original="https://static.tildacdn.com/tild3565-3066-4830-b661-366433323564/0084.JPG"
                                data-zoomable="yes" data-zoom-target="52"
                                data-img-zoom-url="https://static.tildacdn.com/tild3565-3066-4830-b661-366433323564/0084.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">
                            
                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild6234-3833-4262-a234-396337313137/-/format/webp/0085.JPG"
                                data-original="https://static.tildacdn.com/tild6234-3833-4262-a234-396337313137/0085.JPG"
                                data-zoomable="yes" data-zoom-target="53"
                                data-img-zoom-url="https://static.tildacdn.com/tild6234-3833-4262-a234-396337313137/0085.JPG"
                                alt=""/>
                        </div>


 
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">

                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3066-3339-4937-a565-366238366539/-/format/webp/0136.JPG"
                                data-original="https://static.tildacdn.com/tild3066-3339-4937-a565-366238366539/0136.JPG"
                                data-zoomable="yes" data-zoom-target="62"
                                data-img-zoom-url="https://static.tildacdn.com/tild3066-3339-4937-a565-366238366539/0136.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">

                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild6132-3233-4165-a666-326465343639/-/format/webp/0022.JPG"
                                data-original="https://static.tildacdn.com/tild6132-3233-4165-a666-326465343639/0022.JPG"
                                data-zoomable="yes" data-zoom-target="63"
                                data-img-zoom-url="https://static.tildacdn.com/tild6132-3233-4165-a666-326465343639/0022.JPG"
                                alt=""/>
                        </div>
                        <div class="t979__grid-item "  itemscope=""
                            itemtype="http://schema.org/ImageObject">

                            <img class="t979__image t-slds__img t-img" src="https://optim.tildacdn.com/tild3734-6166-4863-a463-613133373931/-/format/webp/0145.JPG"
                                data-original="https://static.tildacdn.com/tild3734-6166-4863-a463-613133373931/0145.JPG"
                                data-zoomable="yes" data-zoom-target="65"
                                data-img-zoom-url="https://static.tildacdn.com/tild3734-6166-4863-a463-613133373931/0145.JPG"
                                alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</>
  
  );
};

export default Gallery;
